import { fetchWrapper, ShopifyParams } from '../../utils';
import { endpoint } from './endpoint';

export function postShopifyAuthCallback(callbackParams: any): Promise<any> {
  return fetchWrapper(endpoint + `/v1/shopify/auth/callback`, {
    method: 'post',
    body: JSON.stringify(callbackParams),
  });
}

export function getShopifyAuthUrl(shop: string): Promise<{ auth_url: string }> {
  return fetchWrapper(endpoint + `/v1/shopify/auth/login?shop=${shop}`, {
    method: 'get',
  }).then((res) => res.json());
}

export function getShopifyAccounts(): Promise<{
  accounts: Array<{ shop: string }>;
}> {
  return fetchWrapper(endpoint + `/v1/shopify/accounts`, {
    method: 'get',
  }).then((res) => res.json());
}

export function connectShopifyShopToCompany(data: ShopifyParams): Promise<any> {
  return fetchWrapper(endpoint + `/v1/shopify/account`, {
    method: 'put',
    body: JSON.stringify(data),
  });
}
